import axios from 'axios';
import { Loading } from 'element-ui';
import store from '../store'
import * as Domain from '../utils/domain.js';

axios.defaults.withCredentials = true;   //等同于在封装的实例里面设置

// http请求拦截器
var loadinginstace,service;

// let baseURL = process.env.API_ROOT;
const baseURL = Domain.getOriginUrl("ide", "service");

//axios配置
service = axios.create({
  baseURL,
  timeout: 30000, 
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },    //自定义请求头信息
});
service.interceptors.request.use(config => {
  loadinginstace = Loading.service({ fullscreen: true });
  return config;
}, error => {
  loadinginstace.close();
  store.state.interfaceErrorShow = true;
  return Promise.reject(error)
});

// http响应拦截器
service.interceptors.response.use(response => {
  if(response.status != '200') store.state.interfaceErrorShow = true;
  loadinginstace.close();
  return response
}, error => {
  loadinginstace.close();
  store.state.interfaceErrorShow = true;
  return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/service/HttpService.js